import { Button, Tags } from "../../ui";

const statusVariants = {
  done: "success",
  complete: "success",
  sent: "success",
  active: "success",
  pending: "warning",
  manual: "info",
  warning: "warning",
  rejected: "danger",
  failed: "danger",
  danger: "danger",
  cancelled: "danger",
  courierNotPickedUp: "warning",
  courierPickedUp: "success",
  normal: "neutral",
};

export function AdminStatus({ children, status = "neutral", className = "" }) {
  return (
    <Tags
      variant={statusVariants[status] || "neutral"}
      appearance="soft"
      size="sm"
      className={className}
    >
      {children}
    </Tags>
  );
}

export function RetryButton({ onClick, children = "إعادة المحاولة" }) {
  return (
    <Button variant="warning" appearance="soft" size="sm" type="button" onClick={onClick}>
      {children}
    </Button>
  );
}

export function AdminPagination({
  page = 1,
  totalPages = 1,
  hasPreviousPage,
  hasNextPage,
  onPrevious,
  onNext,
  label,
}) {
  return (
    <div className="admin-pagination">
      <Button
        variant="neutral"
        appearance="outline"
        size="sm"
        type="button"
        disabled={!hasPreviousPage}
        onClick={onPrevious}
      >
        السابق
      </Button>
      <span>{label || `${page || 1} / ${totalPages || 1}`}</span>
      <Button
        variant="neutral"
        appearance="outline"
        size="sm"
        type="button"
        disabled={!hasNextPage}
        onClick={onNext}
      >
        التالي
      </Button>
    </div>
  );
}
